import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Trophy, Users, ArrowRight } from "lucide-react";
import { API } from "../lib/api";

export default function ChallengeBanner() {
  const [c, setC] = useState(undefined); // undefined=loading, null=none

  useEffect(() => {
    API.get("/sakhi/challenges").then(async (r) => {
      const active = (r.data || []).filter((x) => (x.status || "active") === "active");
      const feat = active[0] || (r.data || [])[0];
      if (!feat) { setC(null); return; }
      try {
        const d = await API.get(`/sakhi/challenges/${feat.id}`);
        setC(d.data);
      } catch { setC({ ...feat, submissions: [] }); }
    }).catch(() => setC(null));
  }, []);

  if (c === undefined || c === null) return null;
  const subs = (c.submissions || []).slice(0, 4);

  return (
    <section className="py-14 sm:py-20 bg-[#FAF6F1]" data-testid="home-challenge-banner">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="relative rounded-3xl overflow-hidden min-h-[380px] grid lg:grid-cols-2">
          <div className="relative min-h-[220px] lg:min-h-full">
            {c.image && <img src={c.image} alt={c.title} className="absolute inset-0 w-full h-full object-cover" />}
            <div className="absolute inset-0 bg-gradient-to-t lg:bg-gradient-to-r from-[#2A1418]/80 to-transparent" />
          </div>
          <div className="bg-[#2A1418] text-white p-8 sm:p-10 flex flex-col justify-center">
            <span className="inline-flex w-fit items-center gap-1.5 bg-[#6A1B29] text-white text-[11px] font-bold px-3 py-1 rounded-full"><Trophy className="w-3.5 h-3.5" /> This Week's Challenge</span>
            <h2 className="font-display text-3xl sm:text-4xl font-semibold mt-4">{c.title}</h2>
            <p className="text-stone-300 mt-3 max-w-md">{c.description}</p>
            <div className="flex items-center gap-4 mt-5 text-sm text-stone-300">
              {c.participants > 0 && <span className="inline-flex items-center gap-1.5" data-testid="challenge-banner-participants"><Users className="w-4 h-4" /> {c.participants} Sakhi{c.participants === 1 ? "" : "s"} joined</span>}
              <span className="text-[#F6A5BE] font-semibold">{c.type} Challenge</span>
            </div>
            {subs.length > 0 && (
              <div className="flex gap-2 mt-5" data-testid="challenge-banner-entries">
                {subs.map((s) => (
                  <div key={s.id} className="w-14 h-14 rounded-xl overflow-hidden bg-white/10 border border-white/15">
                    {s.media?.[0] && <img src={s.media[0]} alt="" className="w-full h-full object-cover" />}
                  </div>
                ))}
              </div>
            )}
            <Link to={`/challenge/${c.id}`} data-testid="challenge-banner-join"
              className="mt-7 w-fit inline-flex items-center gap-2 bg-[#6A1B29] hover:bg-[#501325] text-white font-semibold px-8 py-3.5 rounded-full transition-transform hover:scale-105">
              Join the Challenge <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
